export const ZERO = "zero";

export const LEVEL = {
  increase: "INCREASE",
  decrease: "DECREASE",
};
